import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { SafePipePipe } from './safe-pipe.pipe';
import { ChannelFormatPipe } from './channel.pipe';

@NgModule({
  declarations: [
    KeysPipe,
    GetByIdPipe,
    HtmlToPlaintextPipe,
    FilterPipe,
    CamelCaseToDashPipe,
    LinkifyPipe,
    SafePipePipe,
    ChannelFormatPipe,
  ],
  imports: [],
  exports: [
    KeysPipe,
    GetByIdPipe,
    HtmlToPlaintextPipe,
    FilterPipe,
    CamelCaseToDashPipe,
    LinkifyPipe,
    SafePipePipe,
    ChannelFormatPipe,
  ],
})
export class FusePipesModule {}
